class ProductPosition extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.oldOptionUpdate,
            ({ newVariant }) => this.productStatus(newVariant)
        );
        this.notifyButton();
    }

    notifyButton() {
        const notifyButton = this.querySelector('.quick-jump-bar-item__notify-button');

        
        // 点击按钮模拟点击Stoq插件提供的按钮, 打开弹窗
        notifyButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (window._RestockRocket && typeof window._RestockRocket.openModal === 'function') {
                window._RestockRocket.openModal();
                console.log('Open RestockRocket Modal Successfully');
            } else {
                console.log('RestockRocket Not Loaded');
            }
        });

        if (!notifyButton) {
            // console.log('Notify button not found');
            return;
        }

        // console.log('Notify button found:', notifyButton);

        const paymentContainer = document.querySelector('.product-form__payment-container');

        if (!paymentContainer) {
            // console.log('.product-form__payment-container not found');
            return;
        }

        if (this.reconnectTimer) {
            clearInterval(this.reconnectTimer);
            // console.log('Previous interval cleared');
        }

        this.reconnectTimer = setInterval(() => {
            const siTrigger = document.querySelector('#SI_trigger');

            if (siTrigger) {
                // console.log('appNotifyButton found:', siTrigger);
                clearInterval(this.reconnectTimer);
                this.rebindNotifyButtonClick(notifyButton, siTrigger);
            } else {
                // console.log('appNotifyButton not found');
            }
        }, 1000);

        setTimeout(() => {
            clearInterval(this.reconnectTimer);
            console.log('Timeout: appNotifyButton not found within 60 seconds');
        }, 60000);
    }

    rebindNotifyButtonClick(notifyButton, node) {
        notifyButton.removeEventListener('click', this.notifyButtonClickHandler);

        this.notifyButtonClickHandler = () => {
            node.click();
            // console.log('Notify button clicked');
        };

        notifyButton.addEventListener('click', this.notifyButtonClickHandler);
    }

    productStatus(newVariant) {
        // console.log("传入的数据", newVariant);
        const variantID = newVariant.id;
        // console.log("传入的id", variantID);
        const productUrl = this.dataset.url;
        if (!productUrl) {
            // console.error('未找到产品的 URL');
            return; // 如果没有有效的产品 URL，则直接返回
        }

        // 构建请求参数
        const params = [`section_id=${this.sectionId}`];

        // if (Array.isArray(selectedOptionValues) && selectedOptionValues.length > 0) {
        //     params.push(`option_values=${selectedOptionValues.join(',')}`);
        // }

        // 如果 variantID 存在
        if (variantID) {
            params.push(`variant=${variantID}`);
            // params.push(`option_values=${variantID}`);
        }


        // 构建最终的请求 URL
        const buildRequestUrl = `${productUrl}?${params.join('&')}`;
        // console.log('请求的 URL:', buildRequestUrl);

        // 使用 fetch 请求获取该 URL 的 HTML 内容
        fetch(buildRequestUrl)
            .then((response) => {
                if (!response.ok) {
                    // throw new Error('请求失败：' + response.statusText);
                }
                return response.text(); // 获取响应文本
            })
            .then((responseText) => {
                try {
                    // 使用 DOMParser 将响应文本解析为 HTML 文档
                    const html = new DOMParser().parseFromString(responseText, 'text/html');

                    // 获取返回的 HTML 中的目标元素
                    const id = 'product-position-div'; // 我们需要查找的元素 ID 前缀
                    const source = html.getElementById(`${id}-${this.sectionId}`); // 查找对应 sectionId 的元素
                    const destination = this; // 当前实例，即目标元素
                    // console.log("source", source);
                    // console.log("destination", destination);

                    if (source && destination) {
                        // 如果源元素存在，则将源内容复制到目标容器
                        destination.innerHTML = source.innerHTML;
                        // 重新绑定通知按钮
                        this.notifyButton();
                    } else {
                        // console.warn(`未能找到 ID 为 ${id}-${this.sectionId} 的元素`);
                    }
                } catch (error) {
                    // console.error('HTML 解析错误:', error);
                }
            })
            .catch((error) => {
                // console.error('请求或解析错误:', error);
            });
    }

    get sectionId() {
        return this.dataset.section; // 返回当前组件的 sectionId，通常是数据属性
    }
}

customElements.define('product-position', ProductPosition);
